// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskActor-module__container--3Zho-","avatar":"TaskActor-module__avatar--1hlrC","name":"TaskActor-module__name--1sHbF"};